/**
 * Screenshot capture for the feedback widget. Lifted verbatim from
 * Links'/CMS's `lib/feedback/screenshot.ts`. Never throws: a page with an
 * element html2canvas can't render (a cross-origin iframe, an unusual
 * canvas) should still let the person send feedback - it just goes without
 * a picture.
 */
import html2canvas from 'html2canvas';

/** Server caps the upload at 2MB (413 otherwise) - drop it client-side
 *  rather than let the whole submission fail on an oversized capture. */
const MAX_SCREENSHOT_BYTES = 2 * 1024 * 1024;

export async function captureScreenshot(): Promise<Blob | null> {
  try {
    const canvas = await html2canvas(document.documentElement, {
      logging: false,
      useCORS: true,
    });
    const blob = await new Promise<Blob | null>((resolve) => {
      canvas.toBlob((b) => resolve(b), 'image/png');
    });
    if (!blob || blob.size === 0 || blob.size > MAX_SCREENSHOT_BYTES) return null;
    return blob;
  } catch {
    return null;
  }
}
